<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>档位管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="activeName" type="border-card">

      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <el-table :data="switchManagement" border stripe>
          <el-table-column prop="Name" label="档位名称"></el-table-column>
          <el-table-column prop="operation" label="操作">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="toSpeedChange(scope.$index,scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <SpeedChange ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></SpeedChange>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import SpeedChange from '@/componentsSubVue/SpeedChange.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    SpeedChange
  },
  name: 'MySpeed',
  data () {
    return {
      keywords: {
        jigouid: '-1',
        jigouname: ''
      },
      activeName: 'first',
      switchManagement: []
    }
  },
  mounted () {
    this.apigetspeedlist()
  },
  methods: {
    clicksearch () {
      this.apigetspeedlist()
    },
    BackToFirst (val) {
      this.activeName = 'first'
      this.apigetspeedlist()
    },
    // 跳转到档位修改页
    toSpeedChange (index, row) {
      localStorage.setItem('Speedid', row.Speedid)
      localStorage.setItem('Speed0', row.Speed0)
      localStorage.setItem('Speed1', row.Speed1)
      localStorage.setItem('Speed2', row.Speed2)
      localStorage.setItem('Speed3', row.Speed3)
      localStorage.setItem('Speed4', row.Speed4)
      localStorage.setItem('Speed5', row.Speed5)
      localStorage.setItem('Speed6', row.Speed6)
      localStorage.setItem('Speed7', row.Speed7)
      localStorage.setItem('Speed8', row.Speed8)
      localStorage.setItem('Speed9', row.Speed9)
      localStorage.setItem('Speed10', row.Speed10)

      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData()
    },
    apigetspeedlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getspeedlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.switchManagement = []
            response.data.List.filter((item1, i1) => {
              that.switchManagement.push({
                Speedid: item1.Speedid,
                Name: item1.Name,
                Speed0: item1.Speed0,
                Speed1: item1.Speed1,
                Speed2: item1.Speed2,
                Speed3: item1.Speed3,
                Speed4: item1.Speed4,
                Speed5: item1.Speed5,
                Speed6: item1.Speed6,
                Speed7: item1.Speed7,
                Speed8: item1.Speed8,
                Speed9: item1.Speed9,
                Speed10: item1.Speed10
              })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
